if (!customElements.get('timond-cart-preview')) {
  customElements.define('timond-cart-preview', class extends HTMLElement {
    connectedCallback() {
      this.abort?.abort();
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      this.dialog = this.querySelector('dialog');
      this.image = this.querySelector('[data-preview-image]');
      this.status = this.querySelector('[data-preview-status]');
      this.scope = this.closest('theme-drawer');
      this.scope?.addEventListener('click', event => {
        const link = event.target.closest('[data-cart-preview]');
        if (!link || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        const url = new URL(link.href, location.href);
        if (url.protocol !== 'https:' || url.hostname !== 'cdn.teeinblue.com' || url.username || url.password || typeof this.dialog.showModal !== 'function') return;
        event.preventDefault();
        this.opener = link;
        this.image.hidden = true;
        this.status.hidden = false;
        this.status.textContent = this.status.dataset.loading;
        this.querySelector('[data-preview-product]').textContent = link.dataset.productTitle;
        this.image.src = url.href;
        if (!this.dialog.open) this.dialog.showModal();
      }, options);
      this.image.addEventListener('load', () => {
        this.status.hidden = true;
        this.image.hidden = false;
      }, options);
      this.image.addEventListener('error', () => {
        this.image.hidden = true;
        this.status.hidden = false;
        this.status.textContent = this.status.dataset.error;
      }, options);
      this.querySelector('[data-preview-close]').addEventListener('click', () => this.dialog.close(), options);
      this.dialog.addEventListener('keydown', event => {
        if (event.key === 'Escape' && !event.isComposing) {
          event.preventDefault();
          event.stopPropagation();
          this.dialog.close();
        }
      }, options);
      this.dialog.addEventListener('click', event => {
        event.stopPropagation();
        if (event.target !== this.dialog) return;
        const rect = this.dialog.getBoundingClientRect();
        if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) this.dialog.close();
      }, options);
      this.dialog.addEventListener('close', () => {
        this.image.removeAttribute('src');
        this.image.hidden = true;
        if (this.opener?.isConnected) this.opener.focus({ preventScroll: true });
      }, options);
    }
    disconnectedCallback() {
      this.abort?.abort();
      if (this.dialog?.open) this.dialog.close();
    }
  });
}
